export default __webpack_public_path__ + "static/Feedback_Hover-1775bf9759ef950c3b5edda7ef5fcc59.png";